import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { HELP_DEVICES } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import Device from "./Device";
import DeviceList from "./DeviceList";

export default function Devices() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_DEVICES));
  }, [dispatch]);

  return <MasterDetail identifier="id" master={<DeviceList />} detail={<Device />} />;
}
